import classnames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { Controlled as CodeMirror } from "react-codemirror2"
import FieldWrapper from "../form-utils/FieldWrapper"
import "./CodeEditor.css"
require("codemirror/lib/codemirror.css")
require("codemirror/mode/htmlmixed/htmlmixed")
require("codemirror/theme/material.css")

class CodeEditor extends React.Component {
  componentDidMount() {
    // hack: attempting to refresh the codemirror instance since for whatever reason the
    // codemirror will not dispaly the code initially
    setTimeout(() => {
      this.codeMirror && this.codeMirror.editor.refresh()
    }, 500)
  }

  render() {
    const { value, limit, codeMirrorOptions } = this.props

    const className = classnames("CodeEditor", this.props.className)
    let charRemainingLabel = null
    if (limit) {
      charRemainingLabel = `${(value && value.length) || 0}/${limit}`
    }

    if (codeMirrorOptions && codeMirrorOptions.mode === "htmlmixed") {
      codeMirrorOptions.tags = {
        style: [[null, null, "css"]],
        script: [[null, null, "javascript"]]
      }
    }

    return (
      <FieldWrapper
        {...this.props}
        className={className}
        counter={charRemainingLabel}
      >
        {({ onChange, ...passProps }) => {
          return (
            <div>
              <CodeMirror
                {...passProps}
                ref={(ref) => {
                  this.codeMirror = ref
                }}
                onBeforeChange={(editor, data, val) => {
                  onChange && onChange(val)
                }}
                options={codeMirrorOptions}
              />
            </div>
          )
        }}
      </FieldWrapper>
    )
  }
}

CodeEditor.displayName = "CodeEditor"

CodeEditor.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  limit: PropTypes.number,
  required: PropTypes.bool,
  codeMirrorOptions: PropTypes.shape({
    theme: PropTypes.string,
    mode: PropTypes.oneOf(["htmlmixed", "css", "javascript"])
  })
}

CodeEditor.defaultProps = {
  codeMirrorOptions: {
    theme: "material",
    mode: "htmlmixed"
  },
  autoFocus: true
}

export default CodeEditor
